'use client';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      
      // Calculate progress (0 to 1)
      const progress = docHeight > 0 ? scrollTop / docHeight : 0;
      setScrollProgress(Math.min(Math.max(progress, 0), 1));

      if (scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Circle configuration
  const radius = 20;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - scrollProgress * circumference;

  return (
    <AnimatePresence data-component-id="src/components/ScrollToTop.tsx:43:4" data-component-path="src/components/ScrollToTop.tsx" data-component-line="43" data-component-end-line="90" data-component-file="ScrollToTop.tsx" data-component-name="AnimatePresence" data-component-content="%7B%22elementName%22%3A%22AnimatePresence%22%7D">
      {isVisible && (
        <motion.button data-component-id="src/components/ScrollToTop.tsx:45:8" data-component-path="src/components/ScrollToTop.tsx" data-component-line="45" data-component-end-line="88" data-component-file="ScrollToTop.tsx" data-component-name="motion.button" data-component-content="%7B%22elementName%22%3A%22motion.button%22%2C%22className%22%3A%22fixed%20bottom-6%20right-6%20z-40%20flex%20items-center%20justify-center%20w-12%20h-12%20rounded-full%20bg-%5B%23204653%5D%20text-white%20shadow-lg%20hover%3Abg-%5B%231a3842%5D%20transition-colors%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-offset-2%20focus%3Aring-%5B%23204653%5D%22%7D"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-12 h-12 rounded-full bg-[#204653] text-white shadow-lg hover:bg-[#1a3842] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#204653]"
          aria-label="Scroll to top"
        >
          {/* Progress Ring */}
          <svg data-component-id="src/components/ScrollToTop.tsx:54:10" data-component-path="src/components/ScrollToTop.tsx" data-component-line="54" data-component-end-line="78" data-component-file="ScrollToTop.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%20-rotate-90%22%7D" className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 48 48">
            {/* Background Track */}
            <circle data-component-id="src/components/ScrollToTop.tsx:56:12" data-component-path="src/components/ScrollToTop.tsx" data-component-line="56" data-component-end-line="64" data-component-file="ScrollToTop.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%2C%22className%22%3A%22text-white%2F20%22%7D"
              cx="24"
              cy="24"
              r={radius}
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              className="text-white/20"
            />
            {/* Progress Indicator */}
            <circle data-component-id="src/components/ScrollToTop.tsx:66:12" data-component-path="src/components/ScrollToTop.tsx" data-component-line="66" data-component-end-line="77" data-component-file="ScrollToTop.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%2C%22className%22%3A%22transition-all%20duration-100%20ease-out%22%7D"
              cx="24"
              cy="24"
              r={radius}
              stroke="white"
              strokeWidth="2"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              className="transition-all duration-100 ease-out"
            />
          </svg>

          <svg data-component-id="src/components/ScrollToTop.tsx:80:10" data-component-path="src/components/ScrollToTop.tsx" data-component-line="80" data-component-end-line="87" data-component-file="ScrollToTop.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-5%20h-5%20relative%20z-10%22%7D"
            className="w-5 h-5 relative z-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path data-component-id="src/components/ScrollToTop.tsx:86:12" data-component-path="src/components/ScrollToTop.tsx" data-component-line="86" data-component-end-line="86" data-component-file="ScrollToTop.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </motion.button>
      )}
    </AnimatePresence>
  );
}